/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import InfiniteScroll from '../utils/infiniteScroll';

export default class WithLazyLoad extends React.Component {
  static propTypes = {
    loadMore: PropTypes.func,
    children: PropTypes.node.isRequired,
  };

  componentDidMount() {
    this.initInfiniteScroll();
  }

  componentWillUnmount() {
    this.unscribeInfiniteScroll();
  }

  infiniteScroll = null;

  initInfiniteScroll() {
    const { loadMore } = this.props;

    this.infiniteScroll = new InfiniteScroll({
      element: get(this.listNode, 'parentNode'),
      loadEdgeOffset: 50,
      type: 'lower',
      onLoad: loadMore,
    });
  }

  unscribeInfiniteScroll = () => {
    this.infiniteScroll && this.infiniteScroll.unsubscribe();
  };

  render() {
    const { children } = this.props;
    return (
      <div ref={node => (this.listNode = node)} className="flex flex-column">
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/hocs/withLazyLoad.jsx